import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { formatNumber } from '../../../Utils'
import { withTranslation } from 'react-i18next';

const LaundryItem = ({
    washingAndIroningSelected,
    washingAndIroningPrice,
    washingAndIroningSpeedySelected,
    washingAndIroningSpeedyPrice,
    washingAndManualIroningPrice,
    washingAndManualIroningSelected,
    cleaningAndRefreshing,
    cleaningNotWashing,
    longProcessing,
    t
}) => {
    const canShowExpressLabel = !longProcessing || longProcessing === 0;
    const speedySurcharge = washingAndIroningSpeedyPrice || 0;
    const showExpressOnBaseOption = washingAndIroningSelected && washingAndIroningSpeedySelected;
    const showExpressOnManualOption = washingAndManualIroningSelected && washingAndIroningSpeedySelected;
    const showStandaloneSpeedyOption = washingAndIroningSpeedySelected && !washingAndIroningSelected && !washingAndManualIroningSelected;

    return (
        <ListGroup flush className="shopping-item-section">
            <ListGroupItem className="item-main-header">
                <strong>{t('cart.sections.laundry')}</strong>
            </ListGroupItem>
            {
                washingAndIroningSelected &&
                <ListGroupItem
                    className="item-button single"
                    active={washingAndIroningSelected}
                >
                    <div className="d-flex item-header-font">
                        <div className="item-header">
                        {cleaningNotWashing ? (washingAndManualIroningPrice  ? t('cart.options.cleanNotWashMachine') : t('cart.options.cleanNotWash')) : (cleaningAndRefreshing ? t('cart.options.cleanAndRefresh') : (washingAndManualIroningPrice ? t('cart.options.washAndIronMachine') : t('cart.options.washAndIron')))}
                        {showExpressOnBaseOption && canShowExpressLabel ? ` ${t('cart.options.express')}` : ''}
                        </div>
                        <div className="small-price">
                            {formatNumber(showExpressOnBaseOption ? washingAndIroningPrice + speedySurcharge : washingAndIroningPrice)}
                        </div>
                    </div>
                </ListGroupItem>
            }
            {
                washingAndManualIroningSelected &&
                <ListGroupItem
                    className="item-button single"
                    active={washingAndManualIroningSelected}
                >
                    <div className="d-flex item-header-font">
                        <div className="item-header">
                        {cleaningNotWashing ? t('cart.options.cleanNotWashManual') : (cleaningAndRefreshing ? t('cart.options.cleanAndRefresh') : t('cart.options.washAndManualIron'))}
                        {showExpressOnManualOption && canShowExpressLabel ? ` ${t('cart.options.express')}` : ''}
                        </div>
                        <div className="small-price">
                            {formatNumber(showExpressOnManualOption ? washingAndManualIroningPrice + speedySurcharge : washingAndManualIroningPrice)}
                        </div>
                    </div>
                </ListGroupItem>
            }
            {
                showStandaloneSpeedyOption &&
                <ListGroupItem action className="item-button" active={washingAndIroningSpeedySelected}>
                    <div className="d-flex item-header-font">
                        <div className="item-header">
                            {canShowExpressLabel ? t('cart.options.washAndIronExpress') : t('cart.options.washAndIron')}
                        </div>
                        <div className="small-price">
                            <span>{formatNumber(washingAndIroningSpeedyPrice + washingAndIroningPrice)}</span>
                        </div>
                    </div>
                </ListGroupItem>
            }
        </ListGroup>
    )
}

export default withTranslation()(LaundryItem)